import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { playbookListEntryPoint } from '@atlassian/jira-playbooks-list-screen/src/ui/playbook-list/entrypoint.tsx';
import { playbookLogsEntryPoint } from '@atlassian/jira-playbooks-list-screen/src/ui/playbook-logs/entrypoint.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Argument of type '{ root: ...; getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => any; }' is not assignable to parameter of type 'never'
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const playbookListViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-spa-apps-playbooks-list" */ './src'),
	),
	// This has been causing build errors in unrelated code. Broadening type to fix build.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams): any => {
		const { projectKey } = context.match.params;
		const { tab = 'list', name = '' } = context.query;

		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		// In case where tab is logs, we need to load the logs entry point
		// For other cases, fallback to the list entry point. This matches the current logic in the UI component.
		const entryPoints =
			tab === 'logs'
				? {
						preloadedPlaybookLogsEntryPoint: {
							entryPoint: playbookLogsEntryPoint,
							entryPointParams: {
								cloudId: tenantContext.cloudId,
								projectKey,
								first: 20,
								filter: name ? { name } : null,
							},
						},
					}
				: {
						preloadedPlaybookListEntryPoint: {
							entryPoint: playbookListEntryPoint,
							entryPointParams: {
								cloudId: tenantContext.cloudId,
								projectKey,
								first: 20,
								filter: name ? { name } : null,
							},
						},
					};

		return {
			extraProps: {
				accountId: tenantContext.atlassianAccountId,
				cloudId: tenantContext.cloudId,
				projectId: context.query.projectId,
				projectKey: context.match.params.projectKey,
			},
			entryPoints,
		};
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
}) as any;

export default playbookListViewEntryPoint;
